import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TranslateTemplateBackLink(props) {
  return /*#__PURE__*/_jsx(BackButton, {
    children: /*#__PURE__*/_jsx(Link, {
      onClick: props.onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.backLink"
      })
    })
  });
}
export default function TranslateTemplateSection(props) {
  return /*#__PURE__*/_jsxs(View, {
    paddingBlock: "900",
    paddingInline: "400",
    as: "div",
    children: [/*#__PURE__*/_jsx(TranslateTemplateBackLink, {
      onClick: props.onBackClick
    }), /*#__PURE__*/_jsx(H4, {
      children: props.title
    }), props.children]
  });
}